'use client';

import React, { useState } from 'react';
import Image from 'next/image';

interface AppImageProps {
    src: string;
    alt: string;
    className?: string;
    width?: number;
    height?: number;
    priority?: boolean;
    fill?: boolean;
    sizes?: string;
    quality?: number;
}

export default function AppImage({
    src,
    alt,
    className = '',
    width,
    height,
    priority = false,
    fill = false,
    sizes,
    quality = 85,
}: AppImageProps) {
    const imageSrc = src || '/assets/images/no_image.png';

    if (fill) {
        return (
            <Image
                src={imageSrc}
                alt={alt}
                fill
                className={className}
                sizes={sizes || '100vw'}
                quality={quality}
                priority={priority}
                loading={priority ? 'eager' : 'lazy'}
            />
        );
    }

    return (
        <Image
            src={imageSrc}
            alt={alt}
            width={width || 800}
            height={height || 600}
            className={className}
            sizes={sizes}
            quality={quality}
            priority={priority}
            loading={priority ? 'eager' : 'lazy'}
        />
    );
}